let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5rTzj")).then(() => parcelRequire('5TnZb'));